<template>
    <div
        v-show="hasFilters"
        class="l-ss-c-filters-container"
        :class="{
            'l-ss-c-filters-container-all-filters': isShowHiddenFilters,
        }"
        ref="filtersContainer">
        <div
            class="l-ss-c-filters-top-container"
            ref="filtersTopContainer">
            <div
                v-if="showTopFilters"
                class="l-ss-c-filters-top-list"
                :class="{ 'l-ss-c-filters-top-list-hidden': calculatingFiltersWidth && !filterPositionLeft }"
                ref="topList">
                <filter-container
                    v-for="filter in topFilters"
                    :key="filter.id"
                    :class="{ [`l-ss-c-filters-filter-${filter.type}`]: true, [`l-ss-c-filters-top-item`]: true }"
                    :filter="filter"
                    :has-results="hasResults"
                    :is-short="true"
                    :value="resolveValue(filter)"
                    :all-categories-list="allCategoriesList"
                    :symbol="getSymbol(filter.id)"
                    @change="handleChangeFilter"
                    @change-size="onChangeFiltersSize"
                    @filter-click="params => $emit('filter-click', params)"/>

                <button
                    v-if="activeFiltersCount"
                    class="l-ss-c-filters-clear-btn l-ss-c-button l-ss-c-button-outline"
                    @click="$emit('reset-filters', 'Сбросить фильтры')">
                    <span v-if="!loadingByFilters">Сбросить фильтры</span>
                    <pulse-dots v-else/>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import FilterMixin from './FilterMixin';
    import PulseDots from '@/core/components/pulse-dots';
    import iconFunnel from '@/core/assets/images/icons/funnel.svg';
    import useStickyLeftFilters from '@/core/components/filters/useStickyLeftFilters';

    export default {
        components: {
            PulseDots,
        },
        mixins: [
            FilterMixin,
        ],
        inject: ['scrollToTop'],
        props: {
            currency: {
                type: String,
                default: '',
            },
            hasSelected: {
                type: Boolean,
                default: false,
            },
            sortBy: {
                type: String,
                default: '',
            },
            sortDest: {
                type: String,
                default: '',
            },
            showSorting: {
                type: Boolean,
                default: false,
            },
            filterPositionLeft: {
                type: Boolean,
                default: false,
            },
            searchType: {
                type: String,
                default: 'search-popup',
            },
            allCategoriesList: {
                type: Array,
            },
            loadingByFilters: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                mountedFilters: 0,
                countFiltersForShow: 0,
                calculatingFiltersWidth: true,
                isAllowAllFiltersBtn: true,
                isShowHiddenFilters: false,
                root: null,
                changeFilterSizeTrigger: 0,
                onChangeFiltersSize: () => {
                },
                pauseStickyFilters: null,
                resumeStickyFilters: null,
                waitingForNewFilters: false,
            };
        },
        computed: {
            iconFunnel() {
                return iconFunnel;
            },
            showTopFilters() {
                return this.$screen.isMobile === false;
            },
            showSort() {
                return this.showSorting && this.$configuration.isSortVisible && !this.filterPositionLeft;
            },
            hasFilters() {
                return !!this.filters.length;
            },
            activeFiltersCount() {
                let count = 0;

                this.values.forEach(valueItem => {
                    if (valueItem.options) {
                        count += valueItem.options.length;
                    } else {
                        count += 1;
                    }
                });

                return count;
            },
            checkFilters() {
                const filters = [];

                this.filters.forEach((filter) => {
                    if (!this.$configuration.hiddenFilters.includes(filter.name)) {
                        if (this.$configuration.categoriesAsTree && filter.name === 'category') {
                            filters.push({
                                ...filter,
                                type: 'tree-enum',
                            });
                        } else {
                            filters.push(filter);
                        }
                    }
                });

                return filters;
            },
            topFilters() {
                return this.checkFilters;
            },
        },
        watch: {
            filters() {
                if (this.waitingForNewFilters) {
                    /*
                     * Const root = document
                     *     .querySelector('.l-ss-c-host-node-is-search-popup').shadowRoot
                     *     .querySelector('.l-ss-c-search-top-section-wrapper');
                     * root.scrollIntoView();
                     */
                    this.scrollToTop({
                        onScrollEnd: () => {
                            this.resumeStickyFilters();
                        },
                    });

                    this.waitingForNewFilters = false;
                }
            },
        },
        mounted() {
            if (this.filterPositionLeft) {
                let root = this.$parent.$el.closest('.l-ss-c-root');
                let mainContent;

                if (root.classList.contains('l-ss-c-complex-popup')) {
                    root = root.querySelector('.l-ss-c-complex-search-results-wrapper');
                    mainContent = root.querySelector('.l-ss-c-search-popup-content');
                } else if (root.classList.contains('l-ss-c-complex')) {
                    mainContent = root;
                    root = document;
                } else {
                    root = this.$parent.$el.closest('.l-ss-c-search-popup-wrapper-mask');
                    mainContent = root.querySelector('.l-ss-c-search-popup-content-wrapper');
                }

                const {
                    onChangeFiltersSize,
                    pause,
                    resume,
                } = useStickyLeftFilters(root, this.$refs.filtersTopContainer, mainContent);

                this.onChangeFiltersSize = onChangeFiltersSize;
                this.pauseStickyFilters = pause;
                this.resumeStickyFilters = resume;
            }
        },
        methods: {
            handleChangeFilter(data) {
                if (this.filterPositionLeft) {
                    this.waitingForNewFilters = true;
                    this.pauseStickyFilters();
                }

                this.$emit('filters-change', data);
            },
            showAllFilters() {
                this.countFiltersForShow = this.checkFilters.length;
                this.isAllowAllFiltersBtn = false;
                this.isShowHiddenFilters = true;
            },
        },
    };
</script>
